module.exports = __webpack_public_path__ + "img/faq-bg.32d8cc25.png";